import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    width: "100%",
    minHeight: "calc(100vh - 17rem)",
    justifyContent: "center",
    flexDirection: 'column',
    "& .MuiTypography-root": {
      fontSize: "1.5rem",
    },
  },
})